import classNames from 'classnames';
import { memo } from 'react';
import { ButtonIcon } from '@wg/wows-react-uikit';

import styles from './ButtonAction.scss';

type ButtonActionProps = {
  tooltipContent?: React.ReactNode;
  action: 'ok' | 'cancel';
  isDisabled?: boolean;
  onClick: (event: React.MouseEvent<EventTarget>) => void;
};

const ButtonAction = ({ tooltipContent, action, isDisabled, onClick }: ButtonActionProps) => {
  const classNameContainer = classNames(styles.container, {
    [styles.isDisabled]: isDisabled,
  });

  return (
    <div className={classNameContainer}>
      <ButtonIcon
        isFlat
        type={action === 'ok' ? 'check' : 'cross'}
        isDisabled={isDisabled}
        onClick={onClick}
        tooltipContent={tooltipContent}
      />
    </div>
  );
};

export default memo(ButtonAction);
